'use client';

import createSvg from './createSvg';

export const LogoIcon = createSvg(({ height, width, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <defs>
      <path
        id="sfxx99j9xa"
        d="M21.815 24.978c.91-1.343 1.365-3.498 1.365-6.462 0-2.054-.255-3.815-.761-5.284 0 0-.674-1.497-1.521-2.072-.646-.47-1.417-.754-2.308-.855-.174-.025-5.63-.061-5.63-.061v2.038L3.98 8.666l8.98-3.894v2.16h9.563L22.445 4.5s-.1-1.699-1.26-2.965C20.027.27 18.35.205 18.35.205L5.518.09c-1.787 0-3.07.717-3.85 2.152C.89 3.675.5 5.829.5 8.696c0 1.14.07 2.15.21 3.025.14.875.36 1.604.657 2.189.786 1.623 2.095 2.494 3.885 2.664 1.79.169 5.4.276 5.4.276v-1.994l8.98 3.613-8.98 3.895v-2.21H.979v2.544c.335 2.748 2.108 4.102 4.156 4.294H17.38c2.047 0 3.526-.67 4.436-2.014z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(4 3)">
      <mask id="osx0tsl4hb" fill="#fff">
        <use xlinkHref="#sfxx99j9xa" />
      </mask>
      <use fill="#02C874" xlinkHref="#sfxx99j9xa" />
      <g fill="#02C874" mask="url(#osx0tsl4hb)">
        <path d="M0 0H32V32H0z" transform="translate(-4 -3)" />
      </g>
    </g>
  </svg>
));

export const GlobeIcon = createSvg(({ height, width, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#02C874"
        d="M14 .667C6.64.667.667 6.64.667 14S6.64 27.333 14 27.333 27.333 21.36 27.333 14 21.36.667 14 .667zm-1.333 23.906C7.4 23.92 3.333 19.44 3.333 14c0-.827.107-1.613.28-2.387L10 18v1.333C10 20.8 11.2 22 12.667 22v2.573zm9.2-3.386c-.347-1.08-1.334-1.854-2.534-1.854H18v-4C18 14.6 17.4 14 16.667 14h-8v-2.667h2.666c.734 0 1.334-.6 1.334-1.333V7.333h2.666C16.8 7.333 18 6.133 18 4.667V4.12c3.907 1.587 6.667 5.413 6.667 9.88 0 2.773-1.067 5.293-2.8 7.187z"
        transform="translate(2 2)"
      />
      <path
        fill="#FFF"
        stroke="#02C874"
        strokeWidth="2"
        d="M24.975 16c-.957 0-1.876.486-2.475 1.253-.6-.767-1.518-1.253-2.475-1.253C18.331 16 17 17.45 17 19.297c0 2.266 1.87 4.112 4.703 6.918L22.5 27l.797-.791C26.13 23.409 28 21.563 28 19.297 28 17.451 26.669 16 24.975 16h0z"
        transform="translate(2 2)"
      />
    </g>
  </svg>
));

export const FastDeliveryIcon = createSvg(({ height, width, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#0BE"
        d="M3 15.5C3 22.952 9.034 29 16.486 29 23.953 29 30 22.952 30 15.5S23.952 2 16.486 2C9.034 2 3 8.048 3 15.5z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.5 20c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM21.5 20c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM24 14l-.005-1.414c-.001-.324-.267-.586-.595-.586h-.894L22 14h2z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M21.983 9.867c.047-.211-.005-.432-.14-.6-.137-.169-.343-.267-.56-.267H10.042c-.336 0-.627.232-.7.558l-.138.617H7.675c-.396 0-.717.319-.717.712 0 .393.321.712.717.712h1.21l-.339 1.514H5.9c-.396 0-.717.319-.717.712 0 .393.321.712.717.712h2.328l-.34 1.513h-3.17c-.397 0-.718.32-.718.713 0 .393.321.712.717.712H7.57l-.595 2.658c-.047.211.005.432.14.6.137.169.343.267.56.267h.472c.088-1.448 1.302-2.6 2.782-2.6s2.694 1.152 2.782 2.6h4.494c.064-1.048.718-1.941 1.636-2.354l2.142-8.78zM25.848 16.281c-.116-.144-.286-.243-.476-.281h-3.709L21 18.381c1.603.05 2.903 1.19 3.005 2.619.284-.043.532-.222.63-.484l1.324-3.586c.081-.22.04-.461-.111-.649z"
      />
    </g>
  </svg>
));

export const GroupIcon = createSvg(({ height, width, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <path
      fill="#02C874"
      fillRule="evenodd"
      d="M21.333 14.667c2.214 0 3.987-1.787 3.987-4 0-2.214-1.773-4-3.987-4-2.213 0-4 1.786-4 4 0 2.213 1.787 4 4 4zm-10.666 0c2.213 0 3.986-1.787 3.986-4 0-2.214-1.773-4-3.986-4-2.214 0-4 1.786-4 4 0 2.213 1.786 4 4 4zm0 2.666c-3.107 0-9.334 1.56-9.334 4.667v3.333H20V22c0-3.107-6.227-4.667-9.333-4.667zm10.666 0c-.386 0-.826.027-1.293.067 1.547 1.12 2.627 2.627 2.627 4.6v3.333h8V22c0-3.107-6.227-4.667-9.334-4.667z"
    />
  </svg>
));
